var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    transform: "matrix(-1 0 0 1 60 0.5)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8331 30C35.8331 29.696 35.7305 29.3933 35.5238 29.1467L28.8571 21.1467C28.3865 20.5813 27.5451 20.504 26.9798 20.976C26.4145 21.4467 26.3385 22.2867 26.8091 22.8533L32.7771 30.0147L27.0238 37.164C26.5625 37.7373 26.6531 38.5773 27.2265 39.0387C27.7998 39.5 28.6385 39.4093 29.1011 38.836L35.5385 30.836C35.7345 30.592 35.8331 30.296 35.8331 30Z",
    fill: "#2C3036"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_870",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 20,
    width: 10,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8331 30C35.8331 29.696 35.7305 29.3933 35.5238 29.1467L28.8571 21.1467C28.3865 20.5813 27.5451 20.504 26.9798 20.976C26.4145 21.4467 26.3385 22.2867 26.8091 22.8533L32.7771 30.0147L27.0238 37.164C26.5625 37.7373 26.6531 38.5773 27.2265 39.0387C27.7998 39.5 28.6385 39.4093 29.1011 38.836L35.5385 30.836C35.7345 30.592 35.8331 30.296 35.8331 30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_870)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "matrix(0 1 1 0 14.5 14)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightNav);
export default __webpack_public_path__ + "static/media/right-nav.3037e2471c3dc4342da9a7a330ad6fd7.svg";
export { ForwardRef as ReactComponent };